import { render, staticRenderFns } from "./licenses.vue?vue&type=template&id=55c166aa"
import script from "./licenses.vue?vue&type=script&lang=js"
export * from "./licenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports